import { logoutStart } from 'app/store/actions/auth'
import { store } from 'app/store/store'

export const dispatchLogoutStart = () => {
  store.dispatch(logoutStart())
}
